import type {
  SendCorpoStatsExportArgs,
  FetchCorpoActivityArgs,
  FetchCorpoStatsArgs,
  ApiCorpoActivityRow,
  ApiCorpoStats,
} from './types/corpoStats.types';

import { get, post } from './axios';

export const fetchCorpoStats = async (args: FetchCorpoStatsArgs = {}) => {
  const response = await get<ApiCorpoStats>('/v2/stats/platform/corpo/stats', {
    query: { corpOrganizationId: args.corpOrganizationId },
  });
  return response ?? null;
};

export const fetchCorpoActivity = async (args: FetchCorpoActivityArgs) => {
  const response = await get<ApiCorpoActivityRow[]>(
    '/v2/stats/platform/corpo/activity',
    {
      query: {
        corpOrganizationId: args.corpOrganizationId,
        period: args.period,
      },
    },
  );
  return response ?? [];
};

export const sendCorpoStatsExport = async ({
  corpOrganizationId,
}: SendCorpoStatsExportArgs) => {
  const response = await post<{ sent: boolean }>(
    `/v2/stats/platform/corpo/${corpOrganizationId}/export/send`,
  );
  return response?.data ?? null;
};
